// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"75ae3c42","335":"cdc98744","441":"02191c42","696":"4d205631","737":"f25e4c4d","855":"ed543227","899":"584e293c"}[chunkId] + ".chunk.js";
};